import React from "react";
import { Button } from "@allxsmith/bestax-bulma";
import axios from "axios";
import {useDispatch} from "react-redux";
import {createSetDataFreshAction} from "../../../actions/dataActions";
import {ToastContainer, toast} from "react-toastify";

function WorkshopRow(workshop, dataFresh){
    const dispatch = useDispatch();
    const save = () => {
        const endpoint = "api/contacts/"+workshop.workshop.id;
        const conf ={
            method: "put",
            data: workshop.workshop,
            url: endpoint
        }

        return axios(conf).then((resp) => {
            dispatch(createSetDataFreshAction(dataFresh +2));
        }).catch(err => {toast.error("An error occurred!", {position: "top-right"})});
    }

    const onClick = (e) => {
        workshop.workshop.job_tab = false;
        save().catch(err => {toast.error("An error occurred!", {position: "top-right"})});
    }

    return (
        <tr>
            <td>{workshop.workshop.id}</td>
            <td>{workshop.workshop.display_name}</td>
            <td>
                <Button
                    color={"danger"}
                    onClick={onClick}
                >
                    Delete X
                </Button>
            </td>
        </tr>
    )


}
export default WorkshopRow;